module.exports = "/packs/images/products/usb-charger@3x-338b2a2f326c3c6b1feb565b3f32b651.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/usb-charger@3x.png
// module id = 971
// module chunks = 0 1